module.exports = __webpack_public_path__ + "img/62_2.077697d8.png";